import React, { useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";
import ReactPaginate from "react-paginate";
import Draggable from "react-draggable";
import { useDispatch, useSelector } from "react-redux";
import actions from "../actions";
import Highlighter from "react-highlight-words";
import Loader from "../../common/components/Loader";
import LoadingOverlay from "react-loading-overlay";
import moment from "moment";
import { HistoryRow } from "../../common/components/History/HistoryRow";
import { EllipsisTooltipText } from "../../common/components/EllipsisTextWithTooltip";

const RecommendationLogDetails = props => {
    const dispatch = useDispatch();
    const { getAllRecommendationslogDetailResponse } = useSelector(state => state?.recommendationsReducer);
    const [paginationParams, setPaginationParams] = useState({
        limit: 40,
        offset: 1
    });
    useEffect(() => {
        const log = props?.logDatail;
        dispatch(
            actions?.getRecommendationsLogDetails({
                ...paginationParams,
                recommendation_id: log?.recom_id,
                ...(log?.user_id && { user_id: log.user_id })
            })
        );
    }, [paginationParams]);
    const thousands_separators = num => {
        if (!num) return null;
        let numbe = num.toString();
        let number = numbe.split(".");
        number[0] = number[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return number.join(".");
    };

    const integerValues = [
        "cost",
        "project_total",
        "area",
        "priority",
        "priority_element1",
        "priority_element2",
        "priority_element3",
        "priority_element4",
        "priority_element5",
        "priority_element6",
        "priority_element7",
        "priority_element8",
        "crv",
        "replacement_cost"
    ];
    return (
        <React.Fragment>
            <div
                className="modal assign-init-modal image-pull-modal log-mdl log-detail-modal"
                style={{ display: "block" }}
                id="modalId"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <Draggable handle=".draggable-fav-modal" cancel=".close">
                    <div className="modal-dialog assignModal" role="document">
                        <LoadingOverlay active={getAllRecommendationslogDetailResponse?.isLoading} spinner={<Loader />} fadeSpeed={10}>
                            <div className="modal-content">
                                <div className="modal-header draggable-fav-modal draggable pad-heading align-items-start log-detail-modal-header-wrap">
                                    <div className="log-detail-modal-header flex-grow-1 pr-2">
                                        <h5 className="modal-title log-detail-modal-title mb-2 ml-1" id="exampleModalLabel">
                                            Log Details
                                        </h5>
                                        <div className="log-detail-meta d-flex flex-wrap align-items-center">
                                            <span className="border-active active-col log-detail-chip">
                                                <span className="log-detail-label">Code:</span>
                                                <EllipsisTooltipText className="log-detail-value" text={props?.logDatail?.recom_code ?? "-"} />
                                            </span>
                                            <span className="border-active active-col log-detail-chip">
                                                <span className="log-detail-label">Recommendation:</span>
                                                <EllipsisTooltipText className="log-detail-value" text={props?.logDatail?.recom_desc ?? "-"} />
                                            </span>

                                            <span className="border-active active-col log-detail-chip log-detail-chip--user">
                                                <span className="log-detail-label">User:</span>
                                                <EllipsisTooltipText className="log-detail-value" text={props?.logDatail?.user_name ?? "-"} />
                                            </span>
                                        </div>
                                    </div>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => props.onCancel()}>
                                        <span aria-hidden="true">
                                            <img src="/img/close.svg" alt="" />
                                        </span>
                                    </button>
                                </div>
                                <div className="modal-body ">
                                    <div className="dashboard-outer">
                                        <div className="outer-detail">
                                            <div className="right-panel-section">
                                                <div className="dtl-sec log">
                                                    <div className="tab-dtl region-mng">
                                                        <div className="tab-active buildng-tb">
                                                            <div className="table-section table-scroll build-table p-3">
                                                                <table className="table table-common">
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="img-sq-box">
                                                                                <img src="/img/bell.svg" />
                                                                            </th>
                                                                            <th className="build-code ">All Logs</th>
                                                                            <th className="build-name ">Updated on</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {getAllRecommendationslogDetailResponse?.logs?.length ? (
                                                                            <>
                                                                                {getAllRecommendationslogDetailResponse?.logs?.map((item, i) => (
                                                                                    <HistoryRow
                                                                                        key={item.id}
                                                                                        item={item}
                                                                                        historyParams={paginationParams}
                                                                                        integerValues={integerValues}
                                                                                        hasLogRestore={false}
                                                                                        hasLogDelete={false}
                                                                                        columnConfig={props.columnConfig}
                                                                                    />
                                                                                ))}
                                                                            </>
                                                                        ) : (
                                                                            <tr>
                                                                                <td className="noRecordsColumn" colSpan={7}>
                                                                                    No records found
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            {getAllRecommendationslogDetailResponse?.logs &&
                                                            getAllRecommendationslogDetailResponse?.logs?.length > 0 ? (
                                                                <div className="table-bottom d-flex">
                                                                    <div className="count d-flex col-md-6">
                                                                        <div className="count-dtl">
                                                                            Total Count: <span>{getAllRecommendationslogDetailResponse?.count}</span>
                                                                        </div>
                                                                        <div className="col-md-2 pr-2 selbx">
                                                                            <select
                                                                                className="form-control"
                                                                                value={paginationParams.limit}
                                                                                onChange={e => {
                                                                                    setPaginationParams({
                                                                                        offset: 1,
                                                                                        limit: e.target.value && parseInt(e.target.value)
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <option value="10">10</option>
                                                                                <option value="20">20</option>
                                                                                <option value="30">30</option>
                                                                                <option value="40">40</option>
                                                                                <option value="60">60</option>
                                                                                <option value="100">100</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <div className="pagination-sec col-md-6">
                                                                        <ReactPaginate
                                                                            previousLabel={
                                                                                <span
                                                                                    data-place="top"
                                                                                    data-effect="solid"
                                                                                    data-tip={`Previous`}
                                                                                    data-background-color="#007bff"
                                                                                >
                                                                                    &lt;
                                                                                </span>
                                                                            }
                                                                            nextLabel={
                                                                                <span
                                                                                    data-place="top"
                                                                                    data-effect="solid"
                                                                                    data-tip={`Next`}
                                                                                    data-background-color="#007bff"
                                                                                >
                                                                                    &gt;
                                                                                </span>
                                                                            }
                                                                            breakLabel={"..."}
                                                                            breakClassName={"break-me"}
                                                                            pageCount={Math.ceil(
                                                                                getAllRecommendationslogDetailResponse?.count /
                                                                                    paginationParams?.limit
                                                                            )}
                                                                            marginPagesDisplayed={2}
                                                                            pageRangeDisplayed={5}
                                                                            onPageChange={page => {
                                                                                setPaginationParams({
                                                                                    ...paginationParams,
                                                                                    offset: page?.selected ? page?.selected + 1 : 1
                                                                                });
                                                                            }}
                                                                            containerClassName={"pagination"}
                                                                            subContainerClassName={"pages pagination"}
                                                                            activeClassName={"active"}
                                                                            activeLinkClassName={"active"}
                                                                            forcePage={paginationParams.offset ? paginationParams.offset - 1 : 1}
                                                                        />
                                                                        <ReactTooltip />
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </LoadingOverlay>
                    </div>
                </Draggable>
            </div>
        </React.Fragment>
    );
};

export default RecommendationLogDetails;
